module.exports = __webpack_public_path__ + "menu.png?cd58db1ec48329b86cce223ab9f7a2b5";